import React from 'react'
import { Typography } from '@mui/material'
import { Close, Settings } from '@mui/icons-material'
import { TRoomViewSettingsPopupProps } from './RomViewSettingsPopup.types'
import {
  Actions,
  Backdrop,
  CloseButton,
  Content,
  Header,
  HeaderContent,
  PopupContainer,
  SettingsList,
  SettingsPopupContainer,
} from './RomViewSettingsPopup.styles'
import { useSettingsPopupLogic } from './RomViewSettingsPopup.logic'
import RoomViewSettingsItem from './SettingsItemComponent'

const RoomViewSettingsPopup: React.FC<TRoomViewSettingsPopupProps> = (
  props
) => {
  const { onClose, isOpen } = props
  const logic = useSettingsPopupLogic(props)

  if (!isOpen) return null

  const popupContent = (
    <PopupContainer ref={logic.popupRef}>
      <Header isMobile={logic.isMobile}>
        <HeaderContent>
          <Settings fontSize="small" />
          <Typography variant="h5">Display Settings</Typography>
        </HeaderContent>
        <Actions>
          <CloseButton onClick={onClose} size="small" isMobile={logic.isMobile}>
            <Close />
          </CloseButton>
        </Actions>
      </Header>

      <Content>
        <SettingsList>
          <RoomViewSettingsItem
            label="Procedure Name"
            key="showProcedureName"
            value={logic.roomViewSettings.showProcedureName}
            onChange={(value) =>
              logic.handleSettingToggle('showProcedureName', value)
            }
          />
          <RoomViewSettingsItem
            label="Staff Assignment"
            key="showStaffAssignment"
            value={logic.roomViewSettings.showStaffAssignment}
            onChange={(value) =>
              logic.handleSettingToggle('showStaffAssignment', value)
            }
          />
          <RoomViewSettingsItem
            label="Expected End Time"
            key="showExpectedEndTime"
            value={logic.roomViewSettings.showExpectedEndTime}
            onChange={(value) =>
              logic.handleSettingToggle('showExpectedEndTime', value)
            }
          />
        </SettingsList>
      </Content>
    </PopupContainer>
  )

  return (
    <SettingsPopupContainer>
      {logic.isMobile && <Backdrop onClick={logic.handleBackdropClick} />}
      {popupContent}
    </SettingsPopupContainer>
  )
}

export default RoomViewSettingsPopup
